const wfropData = [
  { climateZone: `Composite`, minWfrop: 12.5 },
  { climateZone: `Hot & Dry`, minWfrop: 10.0 },
  { climateZone: `Warm & Humid`, minWfrop: 16.66 },
  { climateZone: `Temperate`, minWfrop: 12.5 },
  { climateZone: `Cold`, minWfrop: 8.33 },

  // Add any data above this commment
  // Any data added should follow the same syntax
];

export { wfropData };
